"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var FileUpload_1 = __importDefault(require("../FileUpload"));
var constants_1 = require("../constants");
var utils_1 = require("../FileUpload/utils");
var FILE_UPLOAD_DETAILS = constants_1.INPUT_BLOCK_KEYS.FILE_UPLOAD_DETAILS;
var FILE_UPLOAD_SETTINGS = {
    title: 'File Uploads',
    className: '',
    inputs: [
        {
            label: '',
            key: 'handleFileUploads',
            component: FileUpload_1["default"],
            props: function (data, meta, onChange) {
                var _a;
                return ({
                    value: (_a = data[FILE_UPLOAD_DETAILS]) !== null && _a !== void 0 ? _a : utils_1.getInitialFileUploadData(false),
                    options: [
                        {
                            label: 'Default Setting',
                            value: 'default',
                            tooltip: 'In default settings, the files are auto deleted after 72 hours.',
                        },
                        {
                            label: 'Custom Setting',
                            value: 'custom',
                        },
                    ],
                    onChange: onChange,
                });
            },
        },
    ],
};
exports["default"] = FILE_UPLOAD_SETTINGS;
